import { memo, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Link, Stack, Typography, CardContent, Grid, Paper } from '@mui/material';
import { HomeOutlined, Login } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

import { selectAuthenticated, selectPermissions, selectRole } from 'redux/slices/authSlice';
import { getHomeRoute } from 'utilities/routes';

import FullScreenLayout from 'components/layout/fullScreen/fullScreenLayout';
import FullScreenContentBody from 'components/layout/fullScreen/fullScreenContentBody';
import FullScreenCardTitle from 'components/layout/fullScreen/fullScreenCardTitle'
import AnimatedLayout from "components/animationComponents/animatedLayout";
import AnimatedModule from 'components/animationComponents/animatedModule';
import AnimatedSection from 'components/animationComponents/animatedSection';

import googlePlay from 'assets/images/logo-google-play.svg'
import appStore from 'assets/images/logo-app-store.svg'
// import windows from 'assets/images/logo-windows8.svg'
// import mac from 'assets/images/logo-mac-logo.svg'

const Img = ({ img, alt }) => <img src={img} loading='lazy' alt={alt} style={{ height: 50, width: 50 }} />

const GridItem = memo(({ img, alt, label, to }) => {

  const [hover, setHover] = useState(false)

  const handleMouseEnter = () => setHover(true)

  const handleMouseLeave = () => setHover(false)

  return (
    <Link target='_blank' rel='noopener' href={to} underline="none">
      <Paper elevation={hover ? 3 : 0} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} sx={{
        transition: (theme) => theme.transitions.create(),
        bgcolor: (theme) => hover ? theme.palette.primary.main : 'unset',
      }}>
        <Stack direction='row' spacing={2} alignItems='center' >
          <Img img={img} alt={alt} />
          <Typography sx={{
            color: (theme) => hover ? 'white' : theme.palette.primary.main,
            transition: (theme) => theme.transitions.create()
          }}>{label}</Typography>
        </Stack>
      </Paper>
    </Link>
  )
})


const InfoSection = memo(() => {

  const authenticated = useSelector(selectAuthenticated);
  const permissions = useSelector(selectPermissions);
  const role = useSelector(selectRole);

  const navigate = useNavigate()

  const appLink = useMemo(() => 'app://zero-farm', [])

  const { pathPrefix, homeModulePath } = getHomeRoute(role, permissions)

  const handleNavigate = () => {
    navigate(authenticated ? `/${pathPrefix}/${homeModulePath}/` : '/admission/login')
  }

  return (
    <CardContent sx={{ mt: (theme) => theme.spacing(3), mb: (theme) => theme.spacing(3), display: 'flex', flex: 1, alignItems: 'center' }}>
      <AnimatedSection sx={{ flex: 1 }}>

        <Stack>
          <FullScreenCardTitle title='Try App' />

          <Grid container spacing={2} mt={2}>
            <Grid xs={12} item md={6} ><GridItem img={googlePlay} alt='Play Store' to='https://play.google.com/store/apps/details?id=com.monadplug.search' label='Play Store' /></Grid>
            <Grid xs={12} item md={6} ><GridItem img={appStore} alt='App Store' to='https://apps.apple.com/ba/app/monadsearch/id1604061297' label='App Store' /></Grid>
            {/* <Grid xs={12} item md={6} ><GridItem img={windows} alt='Windows' to='https://google.com/search?q=windows' label='Windows' /></Grid> */}
            {/* <Grid xs={12} item md={6} ><GridItem img={mac} alt='Mac' to='https://google.com/search?q=mac' label='Mac' /></Grid> */}
          </Grid>

        </Stack>

        <Stack sx={{mt: 5}}>
          <LoadingButton type="submit" loadingPosition="end" variant="contained" color="primary"
            loading={false} onClick={handleNavigate} endIcon={authenticated ? <HomeOutlined /> : <Login />}
          > {authenticated ? 'Home' : 'Log In'} </LoadingButton>

          <Typography variant='p' sx={{ mt: 2 }} color="text.secondary" gutterBottom align='center'>
            Already downloaded app? <Link tabIndex={-1} href={appLink} underline="hover" >
              Open app </Link> instead
          </Typography>

        </Stack>

      </AnimatedSection>
    </CardContent>
  )
})


export default function Verification() {

  return (
    <AnimatedLayout>
      <FullScreenLayout>
        <AnimatedModule>
          <FullScreenContentBody>
            <Stack direction='row' spacing={0}>
              <InfoSection />
            </Stack>
          </FullScreenContentBody>
        </AnimatedModule>
      </FullScreenLayout>
    </AnimatedLayout>
  )
}
